import { render, staticRenderFns } from "./CoursesEditPage.vue?vue&type=template&id=a456006e&scoped=true&"
import script from "./CoursesEditPage.vue?vue&type=script&lang=ts&"
export * from "./CoursesEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesEditPage.vue?vue&type=style&index=0&id=a456006e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456006e",
  null
  
)

export default component.exports